import Slider, { Settings } from "react-slick";
import { useRef } from "react";

import Container from "shared/ui/container";
import ProgressBarItem, {
  ProgressBarItemStatus,
} from "entities/checkout/progress-bar-item";
import {
  CheckoutTab,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";
import { twMerge } from "tailwind-merge";

const CheckoutProgressBar = () => {
  const {
    currentTab,
    updateCurrentTab,
    checkoutTabs,
    visitedTabs,
    disabledTabs,
  } = useCheckoutTabsContext();

  const sliderRef = useRef<Slider>(null);

  const sliderSettings: Settings = {
    speed: 500,
    slidesToShow: checkoutTabs.length,
    infinite: false,
    arrows: false,
    // responsive: [
    // 	{
    // 		breakpoint: 380,
    // 		settings: {
    // 			slidesToShow: 3,
    // 		},
    // 	},
    // 	{
    // 		breakpoint: 480,
    // 		settings: {
    // 			slidesToShow: 3.5,
    // 		},
    // 	},
    // ],
    swipe: false,
  };

  const onSlideClick = (tab: CheckoutTab, index: number) => {
    if (!visitedTabs.includes(tab.id)) return;
    if (disabledTabs.includes(tab.id)) return;
    if (currentTab.id === tab.id) return;

    updateCurrentTab(tab.id);

    if (!sliderRef.current) return;
    sliderRef.current.slickGoTo(index);
  };

  return (
    <>
      {currentTab.hideNavbar ? (
        <></>
      ) : (
        <Container>
          <nav className={twMerge("gg-relative gg-py-6 md:gg-py-11")}>
            <div className="gg-w-1/6 gg-h-full gg-absolute gg-right-0 gg-top-0 gg-bg-gradient-to-r gg-from-transparent gg-z-10 gg-to-white"></div>

            <div className="gg-text-xs sm:gg-text-base">
              <Slider ref={sliderRef} {...sliderSettings}>
                {checkoutTabs.map((tab: CheckoutTab, index: number) => {
                  if (tab.hidden) return;

                  return (
                    <ProgressBarItem
                      key={`${tab.title}-tab`}
                      tab={tab}
                      id={index}
                      onClick={() => onSlideClick(tab, index)}
                      isDividerActive={
                        visitedTabs.includes(tab.id) &&
                        visitedTabs.includes(checkoutTabs[index + 1].id) // check that we already submitted current step, and proceeded to the next
                      }
                      status={
                        tab.title === currentTab.title
                          ? ProgressBarItemStatus.ACTIVE
                          : visitedTabs.includes(tab.id)
                          ? ProgressBarItemStatus.VISITED
                          : ProgressBarItemStatus.UPCOMING
                      }
                    />
                  );
                })}
              </Slider>
            </div>
          </nav>
        </Container>
      )}
    </>
  );
};
export default CheckoutProgressBar;
